import StoreDetailsInfoContainer from 'components/Store/StoreDetailsInfoContainer'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

function SisterStores({ stores }) {
  const { t: translate } = useTranslation()

  if (!stores || stores.length === 0) {
    return null
  }

  return (
    <div className="store-details-sister-stores">
      <div className="store-details-sister-stores_header">{translate('revenue.sisterStores')}:</div>
      {stores.map(store => (
        <div key={store.storeId} className="store-details-sister-stores_store">
          <StoreDetailsInfoContainer isSisterStore countryId={store.countryId} details={store} />
        </div>
      ))}
    </div>
  )
}

SisterStores.propTypes = {
  stores: PropTypes.arrayOf(PropTypes.object),
}

export default SisterStores
